import { DEPOSIT_STATUS_FILTER } from "../constants/status";
import type { DepositStatusFilter } from "../constants/status";
import type { ItemVariant } from "./utils/item-status";

export const PAGE_SIZE = 50;

/**
 * Estilo padrão dos controles de filtro das tabelas de NSU e extrato, para casar
 * com os SelectInput do resto da feature (h-8, branco, borda cinza, foco amarelo).
 */
export const FILTER_CONTROL_CLASS =
  "h-8 rounded-md border border-[#d1d5db] bg-white px-3 text-xs text-slate-900 " +
  "placeholder:text-slate-400 focus:outline-none focus:border-[#f4c83e]";

export const DEPOSIT_TABLE_HEADERS = {
  BANK: "Banco",
  AGENCY: "Agência",
  ACCOUNT: "Conta",
  DATE: "Data",
  AMOUNT: "Valor",
  DESCRIPTION: "Descrição",
  STATUS: "Status",
} as const;

export const DEPOSIT_TABLE_COLUMN_COUNT: number = Object.keys(DEPOSIT_TABLE_HEADERS).length + 1;

export const DEPOSIT_FILTER_PLACEHOLDERS = {
  BANK: "Banco",
  AGENCY: "Filtrar por agência",
  ACCOUNT: "Filtrar por conta",
  DATE: "Data",
  AMOUNT: "Filtrar por valor",
  DESCRIPTION: "Filtrar por descrição",
  STATUS: "Status",
} as const;

export const NSU_FILTER_PLACEHOLDERS = {
  NUMBER: "Filtrar por número",
  OPERATOR: "Filtrar por operador",
  DATE: "Data",
  AMOUNT: "Filtrar por valor",
} as const;

export const DATE_FILTER_BUTTON_CLASS: string =
  "h-8 w-full justify-start px-3 py-1 text-xs bg-white hover:bg-white text-slate-900 " +
  "border-solid border border-[#d1d5db] hover:border-[#f4c83e]";

export const ITEM_STATUS_LABELS: Record<ItemVariant, string> = {
  free: "Livre",
  draft: "Rascunho",
  reconciled: "Conciliado",
};

export const DEPOSIT_STATUS_OPTIONS: readonly { value: DepositStatusFilter; label: string }[] = [
  { value: DEPOSIT_STATUS_FILTER.PENDING, label: ITEM_STATUS_LABELS.free },
  { value: DEPOSIT_STATUS_FILTER.IN_DRAFT, label: ITEM_STATUS_LABELS.draft },
  { value: DEPOSIT_STATUS_FILTER.RECONCILED, label: ITEM_STATUS_LABELS.reconciled },
];

export const NSU_TABLE_HEADERS = {
  NUMBER: "Número",
  OPERATOR: "Operador",
  DATE: "Data",
  AMOUNT: "Valor",
  ADJUSTED: "Ajustado",
  STATUS: "Status",
} as const;

export const NSU_TABLE_COLUMN_COUNT: number = Object.keys(NSU_TABLE_HEADERS).length + 1;

export const TABLE_EMPTY_TEXT = {
  NSU: "Nenhuma NSU no período.",
  DEPOSIT: "Nenhum depósito no período.",
} as const;

export const FILTER_GROUP_LABELS = {
  NSU: "Filtros das NSUs",
  DEPOSIT: "Filtros dos depósitos",
} as const;

export const TABLE_REFRESHING_CLASS: string = "opacity-60 transition-opacity";
